// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Starr from '../../../Texas/data/counties/Starr.geo.json'
import Hidalgo from '../../../Texas/data/counties/Hidalgo.geo.json'
import Willacy from '../../../Texas/data/counties/Willacy.geo.json'
import Cameron from '../../../Texas/data/counties/Cameron.geo.json'

const counties = {
  Starr,
  Hidalgo,
  Willacy,
  Cameron
}

export default counties
